@if ((isRedirectPage$ | async) === false) {
  @if (isWebView === false) {
    <header [class.home-header]="showGreetings$ | async"></header>
  }

  @if (isWebView === false && (landingPage$ | async) === false) {
    <app-second-header
      [showGreeting]="showGreetings$ | async">
    </app-second-header>
  }
}
<section [class.page]="(isRedirectPage$ | async) === false">
  @if ((isAppLoading$ | async) === false) {
    <router-outlet></router-outlet>
  } @else {
    <app-loader class="global-loader"></app-loader>
  }
</section>
@if ((isRedirectPage$ | async) === false) {
  @if (isWebView === false) {
    <footer></footer>
  }
}


<router-outlet name="payment"></router-outlet>

